import { Stack } from "@mui/material";
import BaZiBaseRow from "./BaZiBaseRow";
import CangGanShenRow from "./CangGanShenRow";
import {
  getYueZhuByYearMonth,
  getRiZhuByDate,
  getShiZhuByRiGanShiChen,
} from "../../utils/baziCalculator";

function getBaZiTable(
  data,
  yun_year,
  liu_year,
  liu_yue,
  liu_ri,
  liu_shi
) {
  let riyuan_title = "";
  if (data.gender === "男") {
    riyuan_title = "元男";
  } else if (data.gender === "女") {
    riyuan_title = "元女";
  } else {
    console.log("error gender ", data.gender);
  }

  const nian_zhu = data.nian_zhu;
  const yue_zhu = data.yue_zhu;
  const ri_zhu = data.ri_zhu;
  const shi_zhu = data.shi_zhu;

  const titleList = ["日期", "年柱", "月柱", "日柱", "时柱"];
  const ganList = ["天干", nian_zhu.gan, yue_zhu.gan, ri_zhu.gan, shi_zhu.gan];
  const zhiList = ["地支", nian_zhu.zhi, yue_zhu.zhi, ri_zhu.zhi, shi_zhu.zhi];

  // 藏干和十神合并为一行
  const cangGanShenList = [
    "藏干",
    { cangGan: nian_zhu.zhi_canggan, zhiShen: nian_zhu.zhi_shen },
    { cangGan: yue_zhu.zhi_canggan, zhiShen: yue_zhu.zhi_shen },
    { cangGan: ri_zhu.zhi_canggan, zhiShen: ri_zhu.zhi_shen },
    { cangGan: shi_zhu.zhi_canggan, zhiShen: shi_zhu.zhi_shen },
  ];

  const ganShenList = [
    "主星",
    nian_zhu.gan_shen,
    yue_zhu.gan_shen,
    riyuan_title,
    shi_zhu.gan_shen,
  ];

  const yn_title_list = [];
  const yn_gan_list = [];
  const yn_zhi_list = [];
  const yn_canggan_shen_list = [];
  const yn_ganshen_list = [];

  if (yun_year) {
    const yun_zhu = data.da_yun[yun_year];
    yn_title_list.push("大运");
    yn_gan_list.push(yun_zhu.gan);
    yn_zhi_list.push(yun_zhu.zhi);
    yn_canggan_shen_list.push({
      cangGan: yun_zhu.zhi_canggan,
      zhiShen: yun_zhu.zhi_shen,
    });
    yn_ganshen_list.push(yun_zhu.gan_shen);
  }
  if (liu_year) {
    const ln_zhu = data.liu_nian[liu_year];
    yn_title_list.push("流年");
    yn_gan_list.push(ln_zhu.gan);
    yn_zhi_list.push(ln_zhu.zhi);
    yn_canggan_shen_list.push({
      cangGan: ln_zhu.zhi_canggan,
      zhiShen: ln_zhu.zhi_shen,
    });
    yn_ganshen_list.push(ln_zhu.gan_shen);
  }

  if (liu_yue && liu_year) {
    const liu_yue_zhu = getYueZhuByYearMonth(
      data.ri_gan,
      liu_year,
      liu_yue
    );
    yn_title_list.push("流月");
    yn_gan_list.push(liu_yue_zhu.gan);
    yn_zhi_list.push(liu_yue_zhu.zhi);
    yn_canggan_shen_list.push({
      cangGan: liu_yue_zhu.zhi_canggan,
      zhiShen: liu_yue_zhu.zhi_shen,
    });
    yn_ganshen_list.push(liu_yue_zhu.gan_shen);
  }

  if (liu_ri && liu_yue && liu_year) {
    // liu_ri 现在是 "M月D日" 格式字符串，如 "2月4日"
    const liu_ri_zhu = getRiZhuByDate(
      data.ri_gan,
      liu_year,
      liu_ri  // 直接传入 "M月D日" 字符串
    );
    yn_title_list.push("流日");
    yn_gan_list.push(liu_ri_zhu.gan);
    yn_zhi_list.push(liu_ri_zhu.zhi);
    yn_canggan_shen_list.push({
      cangGan: liu_ri_zhu.zhi_canggan,
      zhiShen: liu_ri_zhu.zhi_shen,
    });
    yn_ganshen_list.push(liu_ri_zhu.gan_shen);
  }

  if (liu_shi !== undefined && liu_shi !== null && liu_ri && liu_yue && liu_year) {
    const liu_ri_zhu = getRiZhuByDate(
      data.ri_gan,
      liu_year,
      liu_ri  // 直接传入 "M月D日" 字符串
    );
    const liu_shi_zhu = getShiZhuByRiGanShiChen(
      data.ri_gan,
      liu_ri_zhu.gan,
      liu_shi
    );
    yn_title_list.push("流时");
    yn_gan_list.push(liu_shi_zhu.gan);
    yn_zhi_list.push(liu_shi_zhu.zhi);
    yn_canggan_shen_list.push({
      cangGan: liu_shi_zhu.zhi_canggan,
      zhiShen: liu_shi_zhu.zhi_shen,
    });
    yn_ganshen_list.push(liu_shi_zhu.gan_shen);
  }

  titleList.push(...yn_title_list);
  ganList.push(...yn_gan_list);
  zhiList.push(...yn_zhi_list);
  cangGanShenList.push(...yn_canggan_shen_list);
  ganShenList.push(...yn_ganshen_list);

  const baZiTable = {
    titleList: titleList,
    ganList: ganList,
    zhiList: zhiList,
    cangGanShenList: cangGanShenList,
    ganShenList: ganShenList,
  };

  return baZiTable;
}

export default function BaZiBase({
  data,
  yunYear,
  liuYear,
  liuYue,
  liuRi,
  liuShi,
}) {
  const baZiTable = getBaZiTable(data, yunYear, liuYear, liuYue, liuRi, liuShi);
  return (
    <Stack
      direction={"column"}
      spacing={0}
      alignItems="stretch"
      justifyContent="center"
      sx={{
        overflowX: "auto",
        "&::-webkit-scrollbar": {
          height: "8px",
        },
        "&::-webkit-scrollbar-track": {
          background: "#f1f1f1",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#c1c1c1",
          borderRadius: "4px",
        },
      }}
    >
      <BaZiBaseRow data={baZiTable.titleList} dark={true}></BaZiBaseRow>
      <BaZiBaseRow data={baZiTable.ganShenList}></BaZiBaseRow>
      <BaZiBaseRow data={baZiTable.ganList}></BaZiBaseRow>
      <BaZiBaseRow data={baZiTable.zhiList}></BaZiBaseRow>
      <CangGanShenRow data={baZiTable.cangGanShenList} dark={true}></CangGanShenRow>
    </Stack>
  );
}
